import React, { useState, useEffect } from "react";
import PayrollAttendanceControls from "./PayrollAttendanceControls";
import PayrollAttendanceGrid from "./PayrollAttendanceGrid";
import AttendanceTiles from "./AttendanceTiles";
import {
  fetchAttendance,
  fetchWorkingMonths,
  fetchAttendanceSummary,
} from "../Api/PayrollAttendanceservice";
import { useAuth } from "../Context/AuthContext";
import "../Styling/PayrollTheme.css";

const PayrollCockpitAttendance = () => {
  const [filters, setFilters] = useState({
    workingDaysId: "",
    page: 1,
    pageSize: 100,
  });

  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [months, setMonths] = useState([]);
  const [summary, setSummary] = useState({});

  const { user } = useAuth();
  const orgId = user?.organisationId;

  const handlePageChange = (newPage) =>
    setFilters((prev) => ({ ...prev, page: newPage }));

  /* Fetch months */
  useEffect(() => {
    if (!orgId) return;
    fetchWorkingMonths(orgId)
      .then((res) => {
        const formatted = res.map((m) => ({
          workingDaysId: m.workingDaysId,
          year: Number(m.workingYear),
          month: Number(m.workingMonth),
          label: `${m.workingYear}-${String(m.workingMonth).padStart(2, "0")}`,
        }));
        setMonths(formatted);

        const today = new Date();
        const cy = today.getFullYear();
        const cm = today.getMonth() + 1;
        const selected =
          formatted.find((m) => m.year === cy && m.month === cm) ||
          [...formatted].sort((a, b) =>
            a.year === b.year ? b.month - a.month : b.year - a.year,
          )[0];

        if (selected)
          setFilters((prev) => ({
            ...prev,
            workingDaysId: selected.workingDaysId,
            page: 1,
          }));
      })
      .catch(() => setMonths([]));
  }, [orgId]);

  /* Fetch attendance */
  useEffect(() => {
    if (!filters.workingDaysId) return;
    setLoading(true);
    fetchAttendance(filters)
      .then((res) => {
        setData(res?.data || []);
        setTotal(res?.totalCount || 0);
      })
      .finally(() => setLoading(false));
  }, [filters]);

  useEffect(() => {
    if (!filters.workingDaysId) return;

    fetchAttendanceSummary(filters)
      .then(setSummary)
      .catch(() => setSummary({}));
  }, [filters.workingDaysId, filters.resourceId]);

  return (
    <div className="pac-cockpit__page">
      <div className="pac-cockpit__header">
        <h2 className="pac-cockpit__title">Payroll Cockpit — Attendance</h2>
        <p className="pac-cockpit__subtitle">
          View and export employee attendance records
        </p>
      </div>

      <PayrollAttendanceControls
        filters={filters}
        setFilters={setFilters}
        months={months}
      />

      <AttendanceTiles summary={summary} filters={filters} />

      {loading ? (
        <div className="pac-cockpit__loading">
          <span className="pac-cockpit__loading-dot" />
          <span className="pac-cockpit__loading-dot" />
          <span className="pac-cockpit__loading-dot" />
        </div>
      ) : (
        <PayrollAttendanceGrid
          data={data}
          page={filters.page}
          pageSize={filters.pageSize}
          total={total}
          onPageChange={handlePageChange}
          filters={filters}
        />
      )}

      <div className="pac-cockpit__total">
        <strong>Total Records:</strong> {total.toLocaleString()}
      </div>
    </div>
  );
};

export default PayrollCockpitAttendance;
